import { createContext } from 'react';

export type CandleContextType = {
    candleCount: number;
    setCandleCount: (count: number) => void;
};

const CandleContext = createContext<CandleContextType>({} as CandleContextType);

export default CandleContext;